var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 47.0901C40.334 47.0901 47.0901 40.334 47.0901 32C47.0901 23.666 40.334 16.9099 32 16.9099C23.666 16.9099 16.9099 23.666 16.9099 32C16.9099 40.334 23.666 47.0901 32 47.0901ZM37.8615 26.4099H26.1382V28.9066H37.8615V26.4099ZM26.1382 30.7518H37.8615V33.2485H26.1382V30.7518ZM37.8615 35.0934H26.1382V37.5901H37.8615V35.0934Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragger);
export default __webpack_public_path__ + "static/media/dragger.a73fb72b.svg";
export { ForwardRef as ReactComponent };